import React from "react"
import TextField from "material-ui/TextField"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import * as utils from "../../../helpers/utils"
import autobind from "class-autobind"
import { IPositionTask } from "../../../models"
import strings from "../../../localization/strings"
interface IProps {
    handleSave(item: IPositionTask): void
}
interface IState {
    name: string
    errorName: string
    code: string
    errorCode: string
}

export default class TaskEdit extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            code: "",
            errorName: "",
            errorCode: "",
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name) {
            this.setState({ errorName: strings.Input_Name })
            isValidate = false
        }
        else {
            this.setState({ errorName: "" })
        }

        if (!this.state.code) {
            this.setState({ errorCode: strings.Input_Code })
            isValidate = false
        }
        else {
            this.setState({ errorCode: "" })
        }
        return isValidate
    }

    handleDoneClick() {
        if (!this.checkValidate()) return
        const item = {
            Id: utils.guid(),
            Name: this.state.name,
            Code: this.state.code
        }
        this.props.handleSave(item)
    }

    render() {
        return (
            <span style={{ display: "flex" }}>
                <TextField
                    data-intercom-target={"Positions-TaskChip-Entry-Code"}
                    id="code"
                    placeholder={strings.Code}
                    value={this.state.code}
                    style={{ width: 75, marginLeft: 10 }}
                    onChange={e => this.setState({ code: e.target.value }, () => this.checkValidate())}
                    errorText={this.state.errorCode}
                    errorStyle={{ position: "absolute", top: 45 }}
                />
                <TextField
                    data-intercom-target={"Positions-TaskChip-Entry-Name"}
                    id="name"
                    placeholder={strings.Name}
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value }, () => this.checkValidate())}
                    style={{ width: 150, marginLeft: 10 }}
                    errorText={this.state.errorName}
                    errorStyle={{ position: "absolute", top: 45 }}
                />
                <IconButton
                    data-intercom-target={"Positions-TaskChip-Btn-SaveTask"}
                    onTouchTap={this.handleDoneClick}
                >
                    <FontIcon className="fa fa-check-circle-o" />
                </IconButton>
            </span>
        )
    }
}
